<template>
  <div
    id="portal-modal-target"
    class="modals-target"
  />
</template>


<script>
  export default {
    name: 'PortalModalTarget'
  };
</script>
